export default function FeatureCard({
  icon: Icon,
  title,
  desc,
  count,
  animationClass,
  onClick,
  isActive,
  isAnyActive,
}) {
  const isStringIcon = typeof Icon === "string";

  return (
    <div
      onClick={onClick}
      className={`relative flex-1 shadow-md min-w-[200px] bg-white rounded-3xl p-6 flex flex-col gap-4 hover:shadow-lg transition-all duration-300 cursor-pointer
  ${isAnyActive && !isActive ? "opacity-40" : "opacity-100"}
   ${isActive ? "border border-[#007AB7]" : "border-0"}
  ${animationClass || ""}
  
`}
      // style={{
      //   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.09)",
      // }}
    >
      {/* {count !== undefined && (
        <div className="absolute top-3 right-3 text-[#007AB7] text-xl font-bold">
          {count}
        </div>
      )} */}
      <div className="flex items-center justify-between">
      <div className="flex items-center justify-center rounded-full w-11 h-11 bg-[#E0F2FE]">
        {isStringIcon ? (
          <img src={Icon} alt={title} className="object-contain w-8 h-8" />
        ) : (
          Icon && <Icon className="w-5 h-5 text-[#007AB7]" />
        )}
      </div>
       <div className="text-[#007AB7]/50 text-2xl font-bold">
          {count}
        </div>
      </div>
      <div className="flex flex-col gap-1.5 mt-3">
        {/* <p className=" text-2xl font-bold">
          {count}
        </p> */}
        <h3 className="font-semibold text-[12px] text-[#475569] uppercase">{title}</h3>
         
        <p className=" ">{desc}</p>
      </div>
    </div>
  );
}